export const QUERY_KEY = {
    LANDING_DATA: 'CTF_LANDING_MULTIPLE',
    NAVIGATION_ITEMS: 'CTF_NAVIGATION_ITEMS_MULTIPLE',
};
